<div class="container flex column align-items-center">
  <div>
    <div class="header flex row">
      <h1>Upload Segments CSV Report</h1>
    </div>
    <div class="body">
      <div class="flex row">
        <input
          id="inputUploadSegmnetsCsv"
          class="inputUploadSegmnetsCsv"
          type="file"
          accept=".csv"
          (change)="vm.onFileChanges($event)"
        />
      </div>

      <p></p>
      <div class="flex row">
        <ichannel-button
          *ngIf="vm.selectedFile"
          [label]="'Upload'"
          [theme]="'DARK'"
          [callback]="vm.onUploadClickEventHandler.bind(vm)"
        >
        </ichannel-button>
      </div>
    </div>
    <div class="footer flex row">
      <h2 *ngIf="vm.showPreloader">Processing...</h2>
      <table
        class="upload-segments-result"
        *ngIf="vm.resultTable && vm.resultTable.length > 0"
      >
        <thead>
          <tr>
            <th>Status</th>
            <th>Message</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let result of vm.resultTable">
            <td>{{ vm.formatStatus(result.status) }}</td>
            <td>{{ vm.formatResult(result) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
